/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import EndpointsConst from "../consts/EndpointsConst";
import { getAPIUrl } from "../utilities/APIHelper";

class ReviewService {
  /**
   * [POST]
   * Submits review
   * @param {Object} formValues
   *
   * @returns {Promise}
   */
  addReview(formValues) {
    const url = getAPIUrl() + EndpointsConst.API.REVIEWS.ADD_REVIEW;
    return axios.post(url, formValues);
  }

  /**
   * [GET]
   * Retrieves all reviews
   * @returns {Promise}
   */
  getAllReviews() {
    const url = getAPIUrl() + EndpointsConst.API.REVIEWS.GET_ALL_REVIEWS;
    return axios.get(url);
  }
}

export default new ReviewService();
